import { SITE } from "@/lib/site";
import { ButtonLink } from "@/components/ui/Button";

export function HeroStatement() {
  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-8 px-8 pt-40 sm:px-16 sm:pt-48 xl:px-6 lg:flex-row lg:items-end lg:justify-between lg:gap-6 lg:pt-60 short:flex-row short:items-end short:justify-between short:gap-6 short:px-8 short:pt-28">
      <div className="flex max-w-3xl flex-1 flex-col gap-6">
        <h1 className="text-balance text-4xl font-normal leading-tight sm:text-5xl lg:text-6xl short:text-4xl">
          Building Intelligence.
          <br />
          For Hospitality.
        </h1>
        <p className="text-base leading-title tracking-body md:text-lg md:leading-title lg:text-xl short:text-base">
          Somo brings amazing lighting and climate controls to your hotel.
          <br />
          Creating the best guest experience and increasing profits.
        </p>
      </div>
      <ButtonLink
        href={`${SITE}/meet-somo`}
        size="lg"
        className="self-start lg:self-auto short:self-auto"
      >
        Meet Somo
      </ButtonLink>
    </div>
  );
}
